<script setup>
/* eslint-disable */
import { ref, watch, nextTick } from 'vue';
import { useCurrenciesStore } from '@/stores/currencies';
import { MyBets } from '@/stores/MyBets';

const currenciesStore = useCurrenciesStore();
const myBetsStore = MyBets();

const partial_cashout = ref(0);
const show_cash_out_settings = ref(false);
const cashout_verification = ref(false);
const cashout_processing = ref(null);

const props = defineProps({
	betslip: {
		type: Object,
		required: true
	}
})

const sucessfull = ref(null);

// update background of cashout range
watch(partial_cashout, (newValue) => {
	const inputElement = document.querySelector('.cashout-range');
	updateBackground({ target: inputElement });
});

// update background of cashout range
const updateBackground = (event) => {
	const min = event.target.min;
	const max = event.target.max;
	const val = event.target.value;

	const percentage = ((val - min) / (max - min)) * 100;

	event.target.style.background = `linear-gradient(to right, var(--secondary) ${percentage}%, var(--light-dark) ${percentage}%)`;
};

watch(cashout_verification, (newValue) => {
	if (newValue === null && partial_cashout.value > 0 && show_cash_out_settings.value) {
		nextTick(() => {
			const inputElement = document.querySelector('.cashout-range');
			if (inputElement) {
				updateBackground({ target: inputElement });
			}
		});
	}
});

const calculatePartialCashout = (amount) => {
	amount = amount * 0.1;
	return amount.toFixed(2);
};

const calculatePartialCashoutStake = () => {
	if (props.betslip.betslip_stake != 0) return ( Number(props.betslip.betslip_stake) * partial_cashout.value ) / props.betslip.cashout_amount;
	else return ( Number(props.betslip.bonus_stake) * partial_cashout.value ) / props.betslip.cashout_amount ;
};

const openPartialCashout = () => {
	show_cash_out_settings.value = !show_cash_out_settings.value;
	partial_cashout.value = 0;
};


const cashoutBetslip = (betSlip) => {
	if (betSlip.cashout_available == false && betSlip.bonus_can_cashout == false) return;

	if (betSlip.is_mission_betslip && betSlip.mission_can_cashout == false) return;

	if (cashout_processing.value == betSlip.betslip_id) return;

	cashout_processing.value = betSlip.betslip_id;

	if (partial_cashout.value > 0) {
		myBetsStore.partialCashoutBetslip({ betslip_id:betSlip.betslip_id, partial_stake: currenciesStore.format_number(calculatePartialCashoutStake()), partial_cashout_amount: getPartialValue(partial_cashout.value), is_max_cashout: isMaxCashout() }).then(() => {
			cashout_processing.value = null;
			sucessfull.value = true
		}).catch((error) => {
			console.log(error)
			cashout_verification.value = false;
			cashout_processing.value = null;
		});
	} else {
		myBetsStore.cashoutBetslip({ betslip_id:betSlip.betslip_id, cashout_amount: betSlip.cashout_amount }).then(() => {
			cashout_processing.value = null;
			sucessfull.value = true;
		}).catch((error) => {
			console.log(error);
			cashout_verification.value = false;
			cashout_processing.value = null;
		});
	}
}

const calculateCashoutAmount = (cashout_amount) => {
	let max_cashout_amount = null;
	if (props.betslip.cashout.limits && props.betslip.cashout.limits.maximum_cashout_amount != null) {
		max_cashout_amount = Number(props.betslip.cashout.limits.maximum_cashout_amount);
	}

	if (cashout_amount == max_cashout_amount) return cashout_amount
	else cashout_amount = cashout_amount * (Number(props.betslip.cashout.limits.max_partial_cashout_percentage) / 100);

	return cashout_amount;
}

const getPartialValue = (amount) => {
	let max_cashout_amount = null
	if (props.betslip.cashout.limits && props.betslip.cashout.limits.maximum_cashout_amount != null) {
		max_cashout_amount = Number(props.betslip.cashout.limits.maximum_cashout_amount);
		if (props.betslip.cashout_amount < max_cashout_amount) {
			return amount * (Number(props.betslip.cashout.limits.max_partial_cashout_percentage) / 100)
		}
	}
	return amount * (Number(props.betslip.cashout.limits.max_partial_cashout_percentage) / 100)
}

const isMaxCashout = () => {
	let max_cashout_amount = null
	if (props.betslip.cashout.limits && props.betslip.cashout.limits.maximum_cashout_amount != null) {
		max_cashout_amount = Number(props.betslip.cashout.limits.maximum_cashout_amount);
		if (props.betslip.cashout_amount > max_cashout_amount) {
			return true
		}
	}
	return false
}

</script>
<template>
	<template v-if="sucessfull">
		<div class="success-wrap">
			<div class="detail">
				<div class="check-container">
					<svg viewBox="0 0 52 52" width="60" height="60">
						<path class="check" d="M14 27 L22 35 L38 17"/>
					</svg>
				</div>
				<p>{{ $t('general.cashout_successful') }}</p>
			</div>
		</div>
	</template>
	<template v-else-if="betslip.error_message">
		<div class="error_wrap">
			<div class="detail">
				<p>{{ betslip.error_message }}</p>
			</div>
		</div>
	</template>
	<template v-else>
		<template v-if="cashout_verification != betslip.betslip_id && betslip.freebet_id != null">
			<a href="javascript:void(0);"  @click="cashout_verification = betslip.betslip_id" class="btn-secondary cashout-btn betslip-button" style="cursor:pointer;">{{ $t('general.cash_out') }}: {{ currenciesStore.format_currency(betslip.cashout_amount) }}</a>
		</template>
		<template v-else-if="cashout_verification != betslip.betslip_id">
			<div class="cashout-container">
				<div v-if="betslip.cashout.settings.partial_cashout_enabled" class="cashout-buttons">
					<a href="javascript:void(0);" @click="cashout_verification = betslip.betslip_id" class="btn-secondary cashout-btn betslip-button" style="cursor:pointer; width:85%;">
						<template v-if="partial_cashout == 0">
							{{ $t('general.cash_out') }}: {{ currenciesStore.format_currency(betslip.cashout_amount) }}
						</template>
						<template v-else>
							<p v-if="props.betslip.cashout.limits && props.betslip.cashout.limits.max_partial_cashout_percentage" class ="partial-cashout-title">{{ $t('general.cash_out') }}: {{ currenciesStore.format_currency(getPartialValue(partial_cashout)) }}</p>
							<p v-else class ="partial-cashout-title">{{ $t('general.cash_out') }}: {{ currenciesStore.format_currency(partial_cashout) }}</p>
							<p class="partial-cashout-info">{{ $t('betslip.balance_will_be_used_from_stake', { stake: currenciesStore.format_currency(calculatePartialCashoutStake()) }) }}</p>
						</template>
					</a>

					<input type="checkbox" class="btn-secondary cashout-btn betslip-button img-button" @click="openPartialCashout" style="width: 15%; height: 40px;" />
				</div>

				<template v-else>
					<a href="javascript:void(0);"  @click="cashout_verification = betslip.betslip_id" class="btn-secondary cashout-btn betslip-button" style="cursor:pointer;">{{ $t('general.cash_out') }}: {{ currenciesStore.format_currency(calculateCashoutAmount(betslip.cashout_amount)) }}</a>
				</template>

				<div v-if="show_cash_out_settings" class="cashout-settings">
					<div class="cashout-money">
						<p class="cashout-text">{{ calculatePartialCashout(betslip.cashout_amount) }}</p>
						<p class="cashout-text">{{ $t('betslip.choose_cashout_range') }}</p>
						<p v-if="props.betslip.cashout.limits && props.betslip.cashout.limits.max_partial_cashout_percentage" class="cashout-text">{{ calculateCashoutAmount(betslip.cashout_amount) }}</p>
						<p v-else class="cashout-text">{{ betslip.cashout_amount }}</p>
					</div>

					<input class="cashout-range" type="range" step="0.01" :min="calculatePartialCashout(betslip.cashout_amount)" :max="betslip.cashout_amount" v-model="partial_cashout" @input="updateBackground"/>

					<p v-if="props.betslip.cashout.limits && props.betslip.cashout.limits.max_partial_cashout_percentage" class="cashout-text">{{ currenciesStore.format_currency(calculateCashoutAmount(partial_cashout)) }}</p>
					<p v-else class="cashout-text">{{ currenciesStore.format_currency(partial_cashout) }}</p>
				</div>
			</div>
		</template>
		<template v-else>
			<p v-if="betslip.mission_can_cashout == true" style="font-size: 13px; font-weight: 500; color: var(--white); margin-bottom: 10px; text-align:center;">{{ $t('missions.mission_cashout_warning_text') }}</p>
			<template v-else>
				<p v-if="!cashout_processing==betslip.betslip_id" style="font-size: 13px; font-weight: 500; color: var(--white); margin-bottom: 10px; text-align:center;">{{ $t('general.are_you_sure') }}</p>
			</template>
			<div class="cashout-btn-inner">
				<a v-if="cashout_processing==betslip.betslip_id" href="javascript:void(0);" class="btn-small btn-secondary" >
					<div class="loader-main"></div>
				</a>
				<a @click="cashoutBetslip(betslip)" href="javascript:void(0);" class="btn-small btn-secondary betslip-button" v-else>{{ $t('general.yes') }}</a>

				<a @click="cashout_verification = null"  class="btn-small btn-secondary betslip-button">{{ $t('general.no') }}</a>

			</div>
		</template>
	</template>

</template>
<style scoped>
.success-wrap {
    position: relative;
    padding: 2px 3px;
    border: 1px solid var(--primary);
    /* background: var(--red-dark); */
    border-radius: 5px;
    margin-top: 5px;
    margin-bottom: 10px;
    height: 40px;
    z-index: 9;

}

.success-wrap .detail {
	margin-top: 6px;
    display: flex;
    justify-content: center;
    gap: 9px;
	text-align: center;
    color: var(--white);
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
}

.check-container {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #4caf50;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    animation: pop 0.3s ease-out forwards;
  }

  @keyframes pop {
    0% { transform: scale(0); }
    80% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }

  .check {
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    stroke: white;
    stroke-width: 5;
    fill: none;
    animation: draw 0.5s ease forwards 0.3s;
  }

  @keyframes draw {
    to {
      stroke-dashoffset: 0;
    }
  }


.cashout-settings {
	margin-top: 5px;
	padding-bottom: 10px;
}

.cashout-buttons {
	display: flex;
	gap: 10px;
}

.cashout-text {
	font-size: 12px;
	color: var(--white);
	line-height: 1.6;
	display: grid;
	font-weight: 300;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.partial-cashout-title {
	font-size: 13px;
	font-weight: 600;
}

.partial-cashout-info {
	font-size: 12px;
	font-weight: 400;
	/* margin-top: -5px; */
}

.cashout-money {
	display: flex;
	justify-content: space-between;
}

.cashout-range {
	width: 100%;
	background: var(--light-dark);
	height: 3px;
	border-radius: 12px;
	accent-color: var(--secondary);
}

.cashout-range::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	border-radius: 50%;
	width: 12px;
	height: 12px;
	background: var(--secondary);
	cursor: pointer;
}

.cashout-range::-moz-range-thumb {
	border-radius: 50%;
	width: 12px;
	height: 12px;
	background: var(--secondary);
	cursor: pointer;
}

.cashout-range::-moz-range-track {
	height: 3px;
	border-radius: 12px;
}

.img-button {
	background: url('../../../assets/svgs/settings_black.svg') no-repeat center;
	background-size: 20px;
	background-color: var(--secondary);
	transition: all 0.5s !important;
}

.img-button:hover {
	background: url('../../../assets/svgs/settings_white.svg') no-repeat center !important;
	background-size: 20px !important;
	background-color: var(--dark);
	transition: all 0.5s !important;
}

.img-button:checked {
	background: url('../../../assets/svgs/settings_white.svg') no-repeat center !important;
	background-size: 20px !important;
	background-color: var(--dark);
	transition: all 0.5s !important;
	border: 1px solid var(--white) !important;
}

.error_wrap {
    position: relative;
    padding: 2px 3px;
    border: 1px solid var(--red);
    background: var(--red-dark);
    border-radius: 5px;
    margin-top: 5px;
    margin-bottom: 10px;
    z-index: 9;
}

.error_wrap .detail {
    text-align: center;
    color: var(--white);
    font-weight: 300;
    font-size: 11px;
    line-height: 20px;
}

.btn-small  {
	font-size: 13px;
}

</style>